export const DAYS_WITHOUT_REMINDER = 10;

export type PriorityStatus =
  | 'Highly recommended'
  | 'Recommended'
  | 'No action required'
  | 'Not applicable';

export function determinePriorityStatus(
  qualifyingClients: Client[],
  clientsEligibleForReminder: Client[],
  highestPriorityStatus: PriorityStatus,
): PriorityStatus {
  return clientsEligibleForReminder.length > 0
    ? highestPriorityStatus
    : qualifyingClients.length > 0
      ? 'No action required'
      : 'Not applicable';
}

